import React, { FunctionComponent } from "react";
import { useParams } from "react-router-dom";
import { useGetGeneralInfo } from "./hooks";
import { LoadingOverlay, RenderWhen } from "../../../../components";
import {
  ErrorContainer,
  Summary,
  TitleButton,
  utils
} from "../common/dynamicanalysis";
import { Title } from "../../../../components/dynamicanalysis";
import JoeIcon from "./JoeIcon";
import JoeAvailableReports from "./JoeAvailableReports";
import Analysis from "../joe/analysis/Analysis";

const Joe: FunctionComponent = () => {
  const { hash, uploadId } = useParams();
  const { data, isLoading } = useGetGeneralInfo(hash, uploadId);

  if (isLoading) return <LoadingOverlay />;

  const reported = utils.isReported(data?.display_status);

  const showTitleButton =
    Boolean(data?.show_links) &&
    (reported ||
      utils.isOversized(data?.display_status) ||
      utils.isInvalidReport(data?.display_status));

  return (
    <section className="rlbs">
      <Title
        headingLevel="h1"
        icon={<JoeIcon />}
        title={reported ? `Joe Sandbox Analysis Summary` : "Joe"}
      >
        <RenderWhen condition={showTitleButton}>
          <TitleButton
            analysis="Joe"
            taskId={data?.webid ?? data?.task_id ?? ""}
            webServer={data?.web_server ?? ""}
            noTrailingSlash
          />
        </RenderWhen>
      </Title>
      <RenderWhen condition={!reported}>
        <ErrorContainer
          analysis="joe"
          errors={data?.error_info || []}
          isRetryable={Boolean(data?.is_retryable)}
          status={data?.display_status || ""}
        />
      </RenderWhen>
      <RenderWhen condition={reported}>
        <Summary items={data?.general_info ?? []} />

        <hr className="my-20" />

        <JoeAvailableReports
          hash={hash}
          reports={data?.available_reports}
          uploadId={uploadId}
        />

        <Analysis />
      </RenderWhen>
    </section>
  );
};

export default Joe;
